module.exports = __webpack_public_path__ + "static/media/pf2__1_-removebg-preview.47669f8e.png";